import { render, staticRenderFns } from "./TerraIndigenaParaguai.vue?vue&type=template&id=27448bd0&lang=pug"
import script from "./TerraIndigenaParaguai.vue?vue&type=script&lang=js"
export * from "./TerraIndigenaParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports